import React from "react"
import S from "../Sushi/style"

const Combinations = (props) => {
    const items = props.bentos[2] ? props.bentos[2] : []
    const itemsList = items.description.split(", ").map((item, i) => {
        return(
            <S.Wrapper end={(i+1) % 3 === 0} middle={(i-1) % 3 === 0}>{item}</S.Wrapper>
        )
    })
    const sides = props.bentos[3] ? props.bentos[3] : []
    const sidesList = sides.description.split(", ").map((side, i) => {
        return(
            <S.Wrapper end={(i+1) % 3 === 0} middle={(i-1) % 3 === 0}>{side}</S.Wrapper>
        )
    })
    const bentos = props.bentos ? props.bentos : []
    const bentosPrice = bentos[0].price
    console.log(items.description)
    const bentosList = bentos.map((bento, i) => {
        return(
            <S.ItemDescriptionBox key={i}>
                {
                    bento.price ?
                        <>
                        <S.Item description>
                            <S.Name>{bento.name}</S.Name>
                            <S.Price>${bento.price}</S.Price>
                        </S.Item>
                        <S.Description>{bento.description}</S.Description>
                        </>
                    : i === 2 ?
                        <>
                        <S.Item description>
                            <S.Name>{bento.name}</S.Name>
                        </S.Item>
                        <S.Description small><S.Grid>{itemsList}</S.Grid></S.Description>
                        </>
                    :
                        <>
                        <S.Item description>
                            <S.Name>{bento.name}</S.Name>
                        </S.Item>
                        <S.Description small><S.Grid row={2}>{sidesList}</S.Grid></S.Description>
                        </>
                }
            </S.ItemDescriptionBox>
        )
    })
    const sushiCombos = props.sushiCombos ? props.sushiCombos : []
    const sushiCombosList = sushiCombos.map((sushiCombo, i, arr) => {
        return(
            <S.ItemDescriptionBox last={i === arr.length-1} key={i}>
                <S.Item description>
                    <S.Name>{sushiCombo.name}</S.Name>
                    <S.Price>${sushiCombo.price}</S.Price>
                </S.Item>
                <S.Description>{sushiCombo.description}</S.Description>
            </S.ItemDescriptionBox>
        )
    })
    const sushiLunchSpecial = props.sushiLunchSpecial ? props.sushiLunchSpecial : []
    const sushiLunchList = sushiLunchSpecial.map((sushi, i, arr) => {
        return(
            <S.ItemDescriptionBox last={i === arr.length-1} key={i}>
                <S.Item description>
                    <S.Name>{sushi.name}</S.Name>
                    <S.Price>${sushi.price}</S.Price>
                </S.Item>
                <S.Description>{sushi.description}</S.Description>
            </S.ItemDescriptionBox>
        )
    })
    return(
        <S.Container1>
            <S.Container2>
                <S.List>
                    <S.SubCategory>Bento Box</S.SubCategory>
                    {bentosList}
                    <S.SubCategory>Sushi Combo</S.SubCategory>
                    <S.Message>Comes with miso soup or salad</S.Message>
                    {sushiCombosList}
                    <S.SubCategory>Sushi Lunch Special</S.SubCategory>
                    <S.Message>Comes with miso soup or salad <br/> *no substitutions</S.Message>
                    {sushiLunchList}
                </S.List>
            </S.Container2>
        </S.Container1>
    )
}

export default Combinations